import { Box } from "@mui/material"
import { max } from "lodash";
import { useState } from "react";

const locations: Array<string> = [
    "?",
    "Colossus",
    "DMC",
    "DMT",
    "Goron City",
    "Valley",
    "Fortress",
    "Graveyard",
    "Castle",
    "Hyrule field",
    "Kokiri Forest",
    "Kakarico",
    "Lake",
    "LLR",
    "Lost Woods",
    "Market",
    "SFM",
    "Wasteland",
    "Zora Domain",
    "Zora Fountain",
    "Zora River"
]
const LocationSelector = () => {

    let [index, setIndex] = useState(0);


     const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    
            if (e.deltaY > 0)
                if(index === 0)
                    setIndex(locations.length - 1)
                else
                    setIndex(max([0, index - 1]) ?? 0)
            else     
                setIndex((index + 1) % locations.length)          
        }
    return <Box onWheel={handleWheel}  width={150} height={32} sx={{cursor: "pointer"}}>
        {locations[index]}
    </Box>
}

export default LocationSelector